export default "__VITE_ASSET__DC7ZZ1w2__"